$(function() {
	function c() {
		var r = '<p class="l-picture l-photoCenter"><img class="thumbImg" src="' + $(o).eq(n).find("img").attr("src") + '" alt="" title=""><\/p>';
		$(l).html(r);
		$(a).html(function(n) {
			return 0 === n ? t : n
		}(n) + "/" + t);
		$(i).stop().fadeIn("slow");
		$(s).stop().hide().fadeIn("slow");
		$(f).stop().fadeIn("slow");
		$("body").css("overflow", "hidden")
	}
	function d() {
		var r = '<p class="l-picture l-photoCenter"><img class="thumbImg" src="' + $(q).eq(n).find("img").attr("src") + '" alt="" title=""><\/p>';
		$(l).html(r);
		$(a).html(function(n) {
			return 0 === n ? t : n
		}(n) + "/" + t);
		$(i).stop().fadeIn("slow");
		$(s).stop().hide().fadeIn("slow");
		$(f).stop().fadeIn("slow");
		$("body").css("overflow", "hidden")
	}

	function p(n, t, c, d, l) {
		var p, nt, k, b, d, a = t;
		e || (e = !0, f && o.clearTimeout(f), s = void 0, i = l || "", T.readyState = n > 0 ? 4 : 0, p = n >= 200 && n < 300 || 304 === n, c && (b = function(n, t, i) {
			for (var e, u, f, o, s = n.contents, r = n.dataTypes;
				"*" === r[0];) r.shift(), void 0 === e && (e = n.mimeType || t.getResponseHeader("Content-Type"));
			if (e)
				for (u in s)
					if (s[u] && s[u].test(e)) {
						r.unshift(u);
						break
					}
			if (r[0] in i) f = r[0];
			else {
				for (u in i) {
					if (!r[0] || n.converters[u + " " + r[0]]) {
						f = u;
						break
					}
					o || (o = u)
				}
				f = f || o
			}
			if (f) return f !== r[0] && r.unshift(f), i[f]
		}(h, T, c)), b = function(n, t, i, r) {
			var h, u, f, s, e, o = {},
				c = n.dataTypes.slice();
			if (c[1])
				for (f in n.converters) o[f.toLowerCase()] = n.converters[f];
			for (u = c.shift(); u;)
				if (n.responseFields[u] && (i[n.responseFields[u]] = t), !e && r && n.dataFilter && (t = n.dataFilter(t, n.dataType)), e = u, u = c.shift())
					if ("*" === u) u = e;
					else if ("*" !== e && e !== u) {
				if (!(f = o[e + " " + u] || o["* " + u]))
					for (h in o)
						if ((s = h.split(" "))[1] === u && (f = o[e + " " + s[0]] || o["* " + s[0]])) {
							!0 === f ? f = o[h] : !0 !== o[h] && (u = s[0], c.unshift(s[1]));
							break
						}
				if (!0 !== f)
					if (f && n.throws) t = f(t);
					else try {
						t = f(t)
					} catch (n) {
						return {
							state: "parsererror",
							error: f ? n : "No conversion from " + e + " to " + u
						}
					}
			}
			return {
				state: "success",
				data: t
			}
		}(h, b, T, p), p ? (h.ifModified && ((d = T.getResponseHeader("Last-Modified")) && (C.lastModified[r] = d), (d = T.getResponseHeader("etag")) && (C.etag[r] = d)), 204 === n || "HEAD" === h.type ? a = "nocontent" : 304 === n ? a = "notmodified" : (a = b.state, nt = b.data, p = !(k = b.error))) : (k = a, !n && a || (a = "error", n < 0 && (n = 0))), T.status = n, T.statusText = (t || a) + "", p ? v.resolveWith(m, [nt, a, T]) : v.rejectWith(m, [T, a, k]), T.statusCode(w), w = void 0, u && g.trigger(p ? "ajaxSuccess" : "ajaxError", [T, h, p ? nt : k]), y.fireWith(m, [T, a]), u && (g.trigger("ajaxComplete", [T, h]), --C.active || C.event.trigger("ajaxStop")))
	}
	var n, t, o = ".productSlider01 .productSliderItem",
		s = ".lightBox",
		i = ".is-lightBoxBg",
		l = ".lightBoxInner",
		a = ".lightBoxPage",
		f = ".lightBoxBtn",
		e;
	$(o).on("click", function() {
		n = $(o).index(this);
		t = $(".productSlider01 .slick-slide").not(".slick-cloned").length;
		$("body").append('<div class="windowBg is-fadeAnimation is-lightBoxBg"><\/div>');
		$("body").append('<div class="lightBox"><\/div>');
		$("body").append('<p class="lightBoxBtn"><\/p>');
		$(s).append('<div class="lightBoxInner"><\/div>');
		$(s).append('<div class="lightBoxPage"><\/div>');
		$("body").append('<p class="lightBoxPrevBtn"><\/p>');
		$("body").append('<p class="lightBoxNextBtn"><\/p>');
		n === t && (n = 0);
		$(".lightBoxPrevBtn").on("click", function() {
			0 === n ? n = t - 1 : n--;
			c()
		});
		$(".lightBoxNextBtn").on("click", function() {
			n === t - 1 ? n = 0 : n++;
			c()
		});
		c()
	});
	var n, t, q = ".productSlider02 .productSliderItem",
		u = ".lightBox",
		j = ".is-lightBoxBg",
		m = ".lightBoxInner",
		b = ".lightBoxPage",
		h = ".lightBoxBtn",
		f;
	$(q).on("click", function() {
		n = $(q).index(this);
		t = $(".productSlider02 .slick-slide").not(".slick-cloned").length;
		$("body").append('<div class="windowBg is-fadeAnimation is-lightBoxBg"><\/div>');
		$("body").append('<div class="lightBox"><\/div>');
		$("body").append('<p class="lightBoxBtn"><\/p>');
		$(u).append('<div class="lightBoxInner"><\/div>');
		$(u).append('<div class="lightBoxPage"><\/div>');
		$("body").append('<p class="lightBoxPrevBtn"><\/p>');
		$("body").append('<p class="lightBoxNextBtn"><\/p>');
		n === t && (n = 0);
		$(".lightBoxPrevBtn").on("click", function() {
			0 === n ? n = t - 1 : n--;
			d()
		});
		$(".lightBoxNextBtn").on("click", function() {
			n === t - 1 ? n = 0 : n++;
			d()
		});
		d()
	});
	$(".productSlider01").length && (i = {
		autoplay: !1,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: !0,
		arrows: !0,
		fade: !0,
		asNavFor: ".thumbnailInner01",
		fade: !1
	}, ($(".productSlider01").slick(i).slick("setPosition", i), $(".thumbnailInner01").length) && (e = {
		autoplay: !1,
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: ".productSlider01",
		dots: !1,
		vertical: !0,
		focusOnSelect: !0,
		centerMode: !0,
		arrow: !0
	}, $(".l-thumbnailInner01 img"), $(".thumbnailInner01").slick(e).slick("setPosition", e)));
	$(".is-slickFirst").addClass("is-slickFirstActive");
	$(".productSlider02").length && (j = {
		autoplay: !1,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: !0,
		arrows: !0,
		fade: !0,
		asNavFor: ".thumbnailInner02",
		fade: !1
	}, ($(".productSlider02").slick(j).slick("setPosition", j), $(".thumbnailInner02").length) && (f = {
		autoplay: !1,
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: ".productSlider02",
		dots: !1,
		vertical: !0,
		focusOnSelect: !0,
		centerMode: !0,
		arrow: !0
	}, $(".l-thumbnailInner02 img"), $(".thumbnailInner02").slick(f).slick("setPosition", f)));
	$(".is-slickSecond").addClass("is-slickSecondActive");
	new p($(".l-sliderThumbList").children().find("a")),
		function() {
			var t, n;
			if ($(".l-sliderThumbParent").length) {
				t = {
					slidesPerView: "auto",
					speed: 400,
					loop: !1,
					nextButton: ".thumbButtonNext",
					prevButton: ".thumbButtonPrev"
				};
				i();
				$(window).on("resize", function() {
					i()
				});
				n = void 0;

				function i() {
					var i = c;
					i > f && null != n ? (r.a.isArray(n) ? a.each(n, function(n) {
						n.destroy()
					}) : n.destroy(), $(".l-sliderThumbParent").find(".swiper-wrapper").removeAttr("style"), n = void 0) : i <= f && null == n && (n = new l.a(".l-sliderThumbParent .l-sliderThumbContainer", t))
				}
			}
		}
});
$(function() {
	function u() {
		var u = $(t).eq(n).html();
		$(s).html(u);
		$(h).html(n + 1 + "/" + i);
		$(e).stop().fadeIn("slow");
		$(r).stop().hide().fadeIn("slow");
		$(o).stop().fadeIn("slow");
		$("body").css("overflow", "hidden")
	}
	var n, t, i, f = ".lightBoxItem",
		r = ".lightBox",
		e = ".is-lightBoxBg",
		s = ".lightBoxInner",
		h = ".lightBoxPage",
		o = ".lightBoxBtn";
	$(f).length && $(f).on("click", function() {
		t = $(this).parent().find("li");
		n = $(t).index(this);
		i = t.length;
		$("body").append('<div class="windowBg is-fadeAnimation is-lightBoxBg"><\/div>');
		$("body").append('<div class="lightBox"><\/div>');
		$("body").append('<p class="lightBoxBtn"><\/p>');
		$(r).append('<div class="lightBoxInner"><\/div>');
		$(r).append('<div class="lightBoxPage"><\/div>');
		$("body").append('<p class="lightBoxPrevBtn"><\/p>');
		$("body").append('<p class="lightBoxNextBtn"><\/p>');
		$(".lightBoxPrevBtn").on("click", function() {
			0 === n ? n = i - 1 : n--;
			u()
		});
		$(".lightBoxNextBtn").on("click", function() {
			n === i - 1 ? n = 0 : n++;
			u()
		});
		u()
	});
	$("body").on("click", ".is-lightBoxBg, .lightBoxBtn", function() {
		$(e).removeClass("is-fadeAnimation").fadeOut("slow", function() {
			$(this).remove()
		});
		$(r).fadeOut("slow", function() {
			$(this).remove()
		});
		$(o).fadeOut("slow", function() {
			$(this).remove()
		});
		$(".lightBoxPrevBtn").fadeOut("slow", function() {
			$(this).remove()
		});
		$(".lightBoxNextBtn").fadeOut("slow", function() {
			$(this).remove()
		});
		$("body").css("overflow", "auto")
	})
})